var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Container',[_c('Row',[_c('Col',[(_vm.invalid)?_c('ErrorBox',{attrs:{"text":_vm.error}}):_vm._e(),_c('div',{staticClass:"btn-area d-flex bg-dark shadow p-3"},[_vm._t("default")],2)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }